export enum HdpType {
  HDP_ONE = 1,
  HDP_TWO = 2,
}
